import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fa075eac&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa075eac')) {
      api.createRecord('fa075eac', component.options)
    } else {
      api.reload('fa075eac', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fa075eac&", function () {
      api.rerender('fa075eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tN0fvhRuTzZD/JS/offershelp.vue"
export default component.exports